export default "__VITE_ASSET__CQWdWMBp__"